__turbopack_context__.v({
  "closeButton": "PlansCompareModal-module__NHrKhW__closeButton",
  "modalContainer": "PlansCompareModal-module__NHrKhW__modalContainer",
  "modalHeader": "PlansCompareModal-module__NHrKhW__modalHeader",
  "modalScrollArea": "PlansCompareModal-module__NHrKhW__modalScrollArea",
  "modalTitle": "PlansCompareModal-module__NHrKhW__modalTitle",
});
